import css from './solution-channel-groups.scss?inline';

/** Compiled stylesheet, injected as a <style> by both renderers. */
export const SOLUTION_CHANNEL_GROUPS_CSS: string = css;
